const resource = {
    resource_identifier_in_use: 'Die API-Kennung {{indicator}} wird bereits verwendet',
    /** UNTRANSLATED */
    cannot_delete_management_api: 'Cannot delete Logto management API.',
};
export default Object.freeze(resource);
